import React from 'react';
import { Mail, Calendar, MessageSquare, Users, Files, CheckSquare, Cloud } from 'lucide-react';
import { motion } from 'framer-motion';

const AppRail = ({ activeApp, setActiveApp, isMobile }) => {
    if (isMobile) return null;

    const apps = [
        { id: 'mail', icon: Mail, label: 'Mail', color: '#4169E1' },
        { id: 'calendar', icon: Calendar, label: 'Calendar', color: '#4169E1' },
        { id: 'todo', icon: CheckSquare, label: 'ToDo', color: '#4169E1' }
    ];

    return (
        <div style={{
            width: '64px',
            background: 'var(--bg-secondary)', // Subtle contrast background
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px 0',
            zIndex: 100,
            flexShrink: 0,
            borderRight: '1px solid var(--border-glass)'
        }}>
            {/* Segregated Icon Container (Capsule) */}
            <div style={{
                background: 'var(--bg-main)',
                padding: '12px 8px',
                borderRadius: '30px', // Pill/Capsule shape
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.05)',
                border: '1px solid var(--border-glass)'
            }}>
                {apps.map((app) => {
                    const isActive = activeApp === app.id;
                    const Icon = app.icon;

                    return (
                        <motion.div
                            key={app.id}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => setActiveApp(app.id)}
                            style={{
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                position: 'relative',
                                borderRadius: '50%', // Circular items inside capsule
                                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                backgroundColor: isActive ? 'var(--primary-glow)' : 'transparent',
                            }}
                            title={app.label}
                        >
                            <Icon
                                size={20}
                                strokeWidth={isActive ? 2.5 : 2}
                                color={isActive ? 'var(--primary)' : 'var(--text-muted)'}
                                style={{
                                    transition: 'color 0.2s',
                                }}
                            />
                        </motion.div>
                    );
                })}
            </div>
        </div>
    );
};

export default AppRail;

